import socketIOClient from 'socket.io-client'
import md5 from 'blueimp-md5'

import { localhostRoute } from './localhost-route'

const state = {
  endpoint: null,
  socket: null,
  connected: false,
  jwt: null,
  project: null,
  projectdata: null,
  values: null,
  hash: null
}

if (window.location.hostname === 'localhost') {
  // return 'http://localhost:4090';
  state.endpoint = localhostRoute().comms
} else {
  const _hostname = window.location.hostname.replace('labeller', 'communication').replace('label', 'comms').replace('admin', 'comms')
  state.endpoint = window.location.protocol + '//' + _hostname
}

const socketio = {
  is_popped: function () {
    this.broadcast({ type: 'Close', value: true })
  },
  connected: function () {
    return state.connected
  },
  hash: function () {
    return state.hash
  },
  setupConnection: function (username) {
    return new Promise((resolve, reject) => {
      if (!state.connected && !state.socket) {
        const hashWithDate = (username) => {
          const currentDate = new Date().toISOString().slice(0, 10)
          const dataToHash = `${getRandomBase64(10)}${username}${currentDate}`
          return md5(dataToHash).toString()
        }
        state.hash = hashWithDate(username)

        // Enable reconnection
        state.socket = socketIOClient(state.endpoint, {
          reconnection: true,
          reconnectionAttempts: 5,
          reconnectionDelay: 1000,
          reconnectionDelayMax: 5000,
          randomizationFactor: 0.5
        })

        console.log('Socket state.hash', state.hash)

        state.socket.on('connect', () => {
          state.socket.emit('join-room', state.hash)
          console.log('Socket Connected with socket ID:', state.socket.id, 'and hash:', state.hash)
          state.connected = true
          resolve(true)
        })

        state.socket.on('disconnect', () => {
          console.log('Socket Disconnected from server.')
          state.connected = false
          state.socket = null
        })

        state.socket.on('reconnect_attempt', () => {
          console.log('Socket Attempting to reconnect...')
        })

        state.socket.on('reconnect', (attemptNumber) => {
          console.log('Socket Reconnected after attempt', attemptNumber)
          state.socket.emit('join-room', state.hash) // Rejoin the room after reconnecting
        })

        state.socket.on('reconnect_failed', () => {
          console.log('Socket Reconnection failed.')
        })
      } else {
        console.log('Socket Attempt to reconnect or already connected')
        resolve(false)
      }
    })
  },
  sendJwt: function (jwt) {
    if (state.connected && state.socket) {
      console.log('Socket Connected, sending jwt', jwt)
      state.socket.emit('send-jwt', jwt)
      state.jwt = jwt
    } else {
      console.log('Socket Not connected or no socket available to send.')
    }
  },
  selectProject: function (project) {
    if (state.connected && state.socket) {
      console.log('Socket Connected, sending project', project)
      state.socket.emit('select-project', project)
      state.project = project
    } else {
      console.log('Socket Not connected or no socket available to send.')
    }
  },
  broadcast: function (value) {
    if (state.connected && state.socket) {
      console.log('Socket Connected, sending broadcast', value)
      state.socket.emit('broadcast', value)
      state.values = value
    } else {
      console.log('Socket Not connected or no socket available to send.')
    }
  },
  aiBroadcastValues: function (values) {
    if (state.connected && state.socket) {
      console.log('Socket Connected, sending ai broadcast', values)
      state.socket.emit('ai-broadcast', values)
      state.values = values
    } else {
      console.log('Socket Not connected or no socket available to send.')
    }
  },
  registerBroadcastReceiver: function (callback) {
    if (state.connected && state.socket) {
      console.log('Socket Registering broadcast')
      state.socket.on('broadcasted-values', (data) => {
        callback(data)
        console.log('Socket data', data) // Moved inside the callback
      })
    } else {
      console.log('Socket Not connected or no socket available to send.')
    }
  }
}

export default socketio

function getRandomBase64 (length) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  const bytes = new Uint8Array(length)
  crypto.getRandomValues(bytes)
  return Array.from(bytes, byte => chars[byte % chars.length]).join('')
}
